import { LanguageCode } from '../../../../../../i18n/language.ts';

export interface ProjectUrlsResourceTranslations {
    title: {
        github: string;
        live: string;
    };
}

/**
 * Translation resources for project URLs.
 */
type ProjectUrlsResource = {
    [language in LanguageCode]: ProjectUrlsResourceTranslations;
};

/**
 * Overall translation resources for project URLs.
 */
export const projectUrlsResource: ProjectUrlsResource = {
    nl: {
        title: {
            github: 'GitHub',
            live: 'Live Demo'
        }
    },
    en: {
        title: {
            github: 'GitHub',
            live: 'Live Demo'
        }
    }
};